import  React, {useEffect} from "react";
import { useState, useContext, createContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import * as request from "superagent";
import URLManager from '~common/lib/url-manager';
import ErrorView from '~common/components/error-view';
import Renderers from '~common/lib/renderers';
import {cloneDeep} from 'lodash'
import SuccessView from '~common/components/success-view';
import {theme} from "~common/components/app-view/theme";
import { Paper, IconButton, Button } from '@mui/material';
import portalUserContext from '~common/lib/portal-user-context';
import LoadingView from "~common/components/loading-view";
import CookieManager from "~common/lib/cookie-manager";
import ReCaptchaV2 from "react-google-recaptcha";
import SimpleConfirmationModal from "~common/components/simple-confirmation-modal";

import {
    setValueAtPath,
  } from "~common/form/helper";

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import DefinitionSection from "~common/form/definition-section-fc";
import DefinitionSequence from "~common/form/definition-sequence-fc"
import FormBasedActions from '~common/form/form-based-container-actions-fc'
import InstrtuctionsView from "~common/form/form-based-container-instructions-fc"
import FormBasedContainerDialogue from '~common/form/form-based-container-dialogue-fc'
import RendererRegistry from "~common/lib/renderers";

import {DataContext} from "~common/form/icg-definition-data-provider";
import {PolicyContext} from "~common/form/icg-definition-data-provider";
import {DirtyContext} from "~common/form/icg-definition-data-provider";
import {HotKeyMappingContext} from "~common/components/app-view/index";
import translate from "../components/i18n/i18n"


export const ActiveSectionContext = createContext();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionsContainer: {
        marginBottom: 10
    },
    sequenceActionsContainer: {
        marginTop: -29,
        marginLeft: -32,
        marginRight: -32,
        marginBottom: 30
    },
    instructionContainer: {
		marginBottom: 5
	},
	customInfoSectionRenderer: {
		marginBottom: 5
	},
    editorActionBar: {
        marginTop: 15,
        display: "flex",
        justifyContent: "flex-end",
    },
    editorActionBarButton: {
        marginLeft: "15px !important",
    },
    headerPaper: {
        padding: 15,
    },
    actionBar: {
        marginTop: 15,
        display: "flex",
        justifyContent: "flex-end",
    },
        actionBarButton: {
        marginLeft: "15px !important",
    },
    deleteButton: {
        backgroundColor: "#af0202",
        marginLeft: 15,
        "&:hover": {
          backgroundColor: "#5D0A0A !important",
        },
      },
  })
);

export const ContainerTypeTask: string = "task"
export const ContainerTypeEntity: string = "entity"
export const ContainerTypeEditor: string = "editor"

interface FormBasedContainerProps {
    containerType: ContainerTypeEditor | ContainerTypeTask | ContainerTypeEntity
    dataUrl: string;
    readOnly?: boolean; // indicates that the form is readOnly
    readOnlyExceptionPaths?: any; // section paths that are editable in readOnly mode (attachments in AP invoice search)
    channelOverrides?: any;
    actionOverrides?: any;
    match?: any;
    history?: any;
    returnURL?: string;
    useRootTaskData?: boolean;
    // isTask?: boolean;
    entityDataField?: string;
    sequenceView?: boolean;
    formSelector?: any;
    introTemplateSelector?: any;
    summaryTemplateSelector?: any;
    preventFormDefDataKey?: boolean;
    suppressedSections?: any;
    suppressedSectionsFn?: any;
    readOnlySections?: any; // inidicates sections that are readOnly in the sequence view (onboarding profile)
    customInfoSectionRenderer?: any;
    viewTitle?: any;
    showScrollToTop?: boolean;
    successRenderer?: any;
    broadcastUrl?: string; 
    preferredLanguage?: string
    showSequenceInstructions?: boolean
    gridSpacing?: number;
    showErrorsInSnackbar?: boolean
}

export const FormBasedContainer: React.FC<FormBasedContainerProps> = ({
    containerType,
    dataUrl,
    readOnly,
    readOnlyExceptionPaths,
    channelOverrides,
    actionOverrides,
    match,
    history,
    returnURL,
    useRootTaskData,
    // isTask,
    entityDataField,
    formSelector,
    introTemplateSelector,
    summaryTemplateSelector,
    preventFormDefDataKey,
    sequenceView,
    suppressedSections,
    suppressedSectionsFn,
    readOnlySections,
    customInfoSectionRenderer,
    viewTitle,
    showScrollToTop,
    form,
    initData,
    initDataUrl, 
    data,
    postOnly,
    errorFormSelector,
    cachePaths,
    submitButtonText,
    hideCancelButton,
    cancelButtonText,
    allowDelete,
    deleteButtonText,
    onBeforeSubmitAsyncVerify,
    clearDataOnSubmit,
    onAfterSubmitSuccess,
    confirmCancel,
    cancelRedirectUrl,
    confirmCancelMessage,
    confirmDeleteMessage,
    suppressHistory,
    showSectionStatusIcon,
    customRenderers,
    preventCollapse,
    noDefinitionFoundMessage,
    successMessage,
    successRenderer,
    broadcastUrl,
    preferredLanguage,
    showSequenceInstructions,
    gridSpacing,
    showErrorsInSnackbar
}) => {
    const classes = useStyles();   

     // SET THE DEFAULT OF THE CONTAINER TYPE TO EDITOR
     if (!containerType) {
        containerType = ContainerTypeEditor
    }
    
    const [fullData, setFullData] = useContext(DataContext);
    const [policyMessages, setPolicyMessages] = useContext(PolicyContext);
    const [formDirty, setFormDirty] = useContext(DirtyContext);
    const [currentKeyMap, setCurrentKeyMap] = useContext(HotKeyMappingContext);
    
    const [showSuccessRenderer, setShowSuccessRenderer] = useState(false)
    const [status, setStatus] = useState("loading")
    const [error, setError] = useState(undefined)
    const [formDefinition, setFormDefinition] = useState(undefined);
    const [activeSection, setActiveSection] = useState(undefined)
    const [unlockOnbeforeUnload, setUnlockOnbeforeUnload] = useState(readOnly ? false : true)
    const [getNextAvailable, setGetNextAvailable] = useState(undefined)
    const [getNextEnabled, setGetNextEnabled] = useState(undefined)
    const [task, setTask] = useState(undefined)
    const [entity, setEntity] = useState(undefined)
    const [introTemplate, setIntroTemplate] = useState(undefined)
    const [summaryTemplate, setSummaryTemplate] = useState(undefined)
    const [taskType, setTaskType] = useState(undefined)
    const [actionDefinition, setActionDefinition] = useState(undefined)
    const [submitAction, setSubmitAction] = useState(undefined)
    const [actionDialogue, setActionDialogue] = useState(undefined)
    const [dispatching, setDispatching] = useState(false)
    const [saving, setSaving] = useState(undefined)
    const [warningMessage, setWarningMessage] = useState(undefined)
    const [successToasterMessage, setSuccessToasterMessage] = useState(undefined)
    // const [taskSuccessMessage, setSuccessMessage] = useState(undefined)
    const [actionBarMode, setActionBarMode] = useState(readOnly ? "readOnly" : "")
    const [suppressWarnings, setSuppressWarnings] = useState(undefined)
    const [managedWindows, setManagedWindows] = useState(Array<any>())
    const [requireCaptcha, setRequireCaptcha] = useState(undefined)
    const [recaptchaVersion, setRecaptchaVersion] = useState(undefined)
    const [cancelConfirm, setCancelConfirm] = useState(undefined)
    const [confirmDelete, setConfirmDelete] = useState(undefined)


    const isGetNextAvailable = (actionDefintion: any) => {
		var available = false
		if (readOnly) {
			return false
		} else if (actionDefintion.definition && actionDefintion.definition.actions) {
			actionDefintion.definition.actions.forEach((a: any)=>{
				if (a.getNextAvailable) {
					available  = true
				}
			})
		}
		return available
	}

    const handleAPIError = (err: any, terminal?: boolean) => {
        setError(err)
        if (terminal) {
            if (!returnURL) {
                returnURL = "/"
            }
            setTimeout(()=>{
                window.location.href = returnURL
            }, 3000)
        }
	};

    const onErrorViewClose = () => {
        setError(undefined)
    }

    const onWarningViewClose = () => {
        setWarningMessage(undefined)
    }

    const skipSSEBroadcast = () => {
        return (((window as any).App || {}).browserEnvironment || {BROWSER_ENABLE_SSE_BROADCAST: "false"}).BROWSER_ENABLE_SSE_BROADCAST != "true"
    }

    const goHome = (url?: string) => {
        var home = returnURL || "/"
        if (url) {
            home = url
        }
        setUnlockOnbeforeUnload(false)
		window.location.href = home
    }

    const handleDispatch = (action: any, actionData: any) => {

		if (!dispatching) {

			var {id} = match.params

		    var dispatchURL
            
            var entityDispatch, taskDispatch
            if (containerType == ContainerTypeTask) {
                dispatchURL = `/api/${dataUrl}/tasks/${id}/dispatch`

                taskDispatch = cloneDeep(task)
                if (useRootTaskData) {
                    taskDispatch.taskData = fullData
                } else {
                    taskDispatch.taskData[formDefinition.key] = fullData
                }
            } else {

                dispatchURL = `${dataUrl}/${id}/dispatch`
                if (sequenceView) {
                    dispatchURL = `${dataUrl}/dispatch`
                }

                entityDispatch = cloneDeep(entity)

                if (entityDataField) {
                    
                    if (!preventFormDefDataKey) {
                        entityDispatch[entityDataField][formDefinition.key] = fullData
                    } else {
                        entityDispatch[entityDataField] = fullData
                    }
                } else {
                    entityDispatch = fullData
                }

            }

            if (readOnlySections && readOnlySections.length > 0) {
                var idx = 0
                for (let section of readOnlySections) {
                    if (idx == 0) {
                        dispatchURL += `?readOnlySections=${section}`
                    } else {
                        dispatchURL += `&readOnlySections=${section}`
                    }
                    idx++
                }
            }

			// Stamp some user info onto the action data
			actionData = actionData || {};
			actionData.userContext = {
				"userID": portalUserContext.actionUserID,
				"userFullName": portalUserContext.actionUserFullName,
				"userName": portalUserContext.actionUserName,
				"userType": portalUserContext.userType
			}

			var dispatchRequest: any = {
				action: action,
				actionData: actionData
			}

            if (!skipSSEBroadcast() && broadcastUrl) {
                dispatchRequest.broadcastUrl = broadcastUrl
            }

            if (taskDispatch) {
                dispatchRequest.task = taskDispatch
            } else {
                dispatchRequest.entity = entityDispatch
                dispatchRequest.id = id
            }

            dispatchRequest["_suppressWarnings"] = suppressWarnings;

			dispatchRequest.actionData.getNextEnabled = getNextEnabled


            
			dispatchURL = `${dispatchURL}?q=${URLManager.getQueryStringValueByKey("q", window.location.href)}`
            
            

            setDispatching(true)
            setActionDialogue(undefined)

			request.put(dispatchURL).send(dispatchRequest).then((response: request.Response)=>{
				
                var _fullData = cloneDeep(fullData)

                if (response.body.task) {
                    _fullData = response.body.task.taskData[formDefinition.key]

                    if (useRootTaskData) {
                        _fullData = response.body.task.taskData
                    }
                }

                if (response.body.entity) {
                    _fullData = response.body.entity
                    if (entityDataField) {
                        _fullData = _fullData[entityDataField]
                        if (!preventFormDefDataKey) {
                            _fullData = _fullData[formDefinition.key]
                        }
                    }
                }

                if (response.body.policyMessages) {

                    let hasWarning = false;
                    for (let pm of response.body.policyMessages) {
                        if (pm.severity == 1) {
                            hasWarning = true;
                        }
                    }

                    setSuppressWarnings(hasWarning)
                    setFullData(_fullData)
                    setPolicyMessages(response.body.policyMessages)
                    setError("One or more policy violations has occurred")
                    setDispatching(false)

                    if (sequenceView) {
                        // navigate to the section for the first policy message
                        // Get an array of specific sections (keys) from the definition
                       var sections:Array<string>;
                        if (formDefinition){
                            sections = (formDefinition.definitions||[]).map((d) => d.key);
                        }

                        // Locate the section for the first policy message which has a path pointing to a section
                        let navSection = response.body.policyMessages.find(el => {
                            if (el.path) {
                                var p = el.path[0] == "/" ? el.path.split("/")[1] : el.path.split("/")[0]
                                if (p.length > 0) {
                                    if(el.path.indexOf(p) > -1){
                                        if (sections.includes(p)) {
                                            // Since this returns an object and we don't care to split out the path again, just do this
                                            el.gotoSection = p
                                            
                                            return true
                                        }
                                    }
                                }
                            }
                        });  
    
                        if (navSection) {
                            setActiveSection(navSection.gotoSection)
                        }
                    }

                } else {
                    if (response.body.task || response.body.entity) {

                        setFormDirty(true)
                        setTask(response.body.task)
                        setEntity(response.body.entity)
                        setFullData(_fullData)
                        setDispatching(false)

                        if (response.body.successMessage) {
                            setSuccessToasterMessage(response.body.successMessage)
                        }
                     
                    } else {
                        // send the user back if get next is not available
                        if (!action.getNextAvailable && !response.body.nextTask) {
                            if (action && action.title && action.title.toLowerCase() == "close" && window.opener) {
                                window.close()
                            } else {
                                goHome(response.body.redirectToUrl)
                                return
                            }
                        }

                        // we got the next task
                        if (response.body.nextTask) {
                            // load next task
                            var {id} = match.params
                            var url = window.location.pathname

                            // update the url with the new task id
                            url = url.replace(`/${id}`, `/${response.body.nextTask.id}`)

                            
                            history.push(`${url}${window.location.search}`)

                            setTask(response.body.nextTask)

                            var formData = response.body.nextTask.taskData[formDefinition.key]
                            if (useRootTaskData) {
                                formData = response.body.nextTask.taskData
                            }
                            setFullData(formData)
                            setDispatching(false)
                            setFormDirty(false)
                            tabToNextAvailableElement(null, true)

                            if (managedWindows && managedWindows.length > 0) {
                                managedWindows.forEach((mw:any)=>{
                                    postWindowMessage({ source: mw, data: {"action": "updateID", "newID": response.body.nextTask.id} })
                                })
                            }
                        
                            return
                        }
                        

                        if (!getNextEnabled) {
                            // get next isn't enabled, send the user back.
                            goHome()
                        } else {
                            if (!response.body.nextTask) {
                                // getNext is enabled, but we didnt get a new task. notify the user.
                                setWarningMessage("There are no more items to process")
                                setTimeout(()=>{
                                    goHome()
                                }, 3000)
                            } else if (response.body.getNextError) {
                                // task was succesfully dispatched, but error encountered during getNext.
                                setWarningMessage( "Unable to get the next task. Please contact a system administrator if the problem persists.")
                                setTimeout(()=>{
                                    goHome()
                                }, 3000)
                            } else {
                                goHome()
                            }
                        }					
                    }
                    
                }
                    
            }).catch((err)=>{
                setDispatching(false)
                handleAPIError(err)
            })
		}
	}

    const postWindowMessage = (message: any) => {
        if (message && message.data) {
            if (managedWindows.length > 0) {
                switch ((message.data.action || "").toLowerCase()) {
                    case "updateid":
						message.source.postMessage({
							action: message.data.action,
							data: message.data,
						}, window.location.origin);
						break;
                }
            }
        }
    }

    const renderDefinitionView = () => {
        if (!sequenceView) {
            var viewTitleData 
            if (containerType == ContainerTypeTask) {
                viewTitleData = task
            } else if (containerType == ContainerTypeEntity) {
                viewTitleData = fullData
            }

            return (
                <Paper>
                    <DefinitionSection
                        showErrorsInSnackbar={showErrorsInSnackbar}
                        titleOverride={viewTitle ? viewTitle(viewTitleData,taskType) : undefined}
                        definition={formDefinition}
                        path={""}
                        readOnly={readOnly}
                        readOnlyExceptionPaths={readOnlyExceptionPaths}
                        suppressHistory={suppressHistory}
                        showSectionStatusIcon={showSectionStatusIcon}
                        customRenderers={customRenderers}
                        preventCollapse={preventCollapse}
                        noDefinitionFoundMessage={noDefinitionFoundMessage}
                        onHistoryViewToggle={onHistoryViewToggle}
                        gridSpacing={gridSpacing}
                    />
                </Paper>
            )
        } else {
            return (
                <ActiveSectionContext.Provider value={[activeSection, setActiveSection]}>
                    <DefinitionSequence
                        formDefinition={formDefinition}
                        setError={setError}
                        readOnly={readOnly}
                        readOnlySections={readOnlySections}
                        submitAction={submitAction}
                        suppressedSections={suppressedSections}
                        suppressedSectionsFn={suppressedSectionsFn}
                        suppressWarnings={suppressWarnings}
                        setSuppressWarnings={setSuppressWarnings}
                        introTemplate={introTemplate}
                        summaryTemplate={summaryTemplate}
                        match={match}
                        history={history}
                        task={task}
                        showSequenceInstructions={showSequenceInstructions}
                        handleAction={handleAction}
                        onHistoryViewToggle={onHistoryViewToggle}
                    />
                </ActiveSectionContext.Provider>
            )
        }
    }

    const onHistoryViewToggle = (enabled: boolean) => {
        switch (enabled) {
			case true:
                setActionBarMode("history")
				break
			case false:
				if (readOnly) {
                    setActionBarMode("readOnly")
				} else {
                    setActionBarMode("")
				}
		}
    }

    const handleAction = (action: any) => {
        if (action.dialogueOptions && (action.dialogueOptions.title || action.dialogueOptions.renderer) && (action.dialogueOptions.requireDirty && formDirty || !action.dialogueOptions.requireDirty)) {
			
            setActionDialogue(action)

		} else if (action.popoutURL) {
			var {id} = match.params

            var mw = cloneDeep(managedWindows)

			const fn = (event) => {
                mw.forEach((w) => {
                    w.close()
                })
			}

			window.addEventListener("unload", fn);
			var windowKey = action.title
			if (action.windowKey) {
				windowKey = action.windowKey
			}
			mw.push(window.open(action.popoutURL+id, windowKey, "resizable=1,address=no,height=800,width=640,location=no"))

            setManagedWindows(mw)

		} else {
            if (actionOverrides && actionOverrides[action.title] ) {
                actionOverrides[action.title]()
            } else {
                handleDispatch(action, {})
            }
		}
    }

    const handleModalClose = () => {
        setActionDialogue(undefined)
    }

    const onCaptchaChange = (data) => {
        setRequireCaptcha(true)
        validateCaptcha(data)
    }

    const validateCaptcha = (token: string) => {
        if (!token) {
          setRequireCaptcha(true)
        } else {
          const body: any = {
            token: token,
          };
          request
            .post("/api/validate-captcha")
            .send(body)
            .set("Content-Type", "application/json")
            .then((response) => {
              setRequireCaptcha(false)
            });
        }
    };

    const handleSuccessMessageClose = () => {
        setSuccessToasterMessage(undefined)
        if (returnURL && containerType == ContainerTypeEditor) {
            window.location.href = returnURL;
        }
    }

    // editor container type
    const handleSubmit = () => {

        const self = this;
        let updateUrl = dataUrl;
        
        /*************************************************
         *
         *  Save the data, looking for policy messages
         *  on body when status is not OK
         *
         *************************************************/

        var subResp: any;

        // Determine whether to put or post based on a valid ID
        var fn: any = request.post;
        if (!postOnly && fullData.id) {
            fn = request.put;
            updateUrl = updateUrl + "/" + fullData.id;
        } else if (!postOnly && match.params.id) {
            fn = request.put;
            updateUrl = updateUrl + "/" + match.params.id;
        }

        // Inject the form key and selector in case the handler needs that.
        fullData["_formKey"] = formDefinition.key;
        fullData["_formSelector"] = formSelector;
        fullData["_suppressWarnings"] = suppressWarnings;

        // show spinner
        setSaving(true)

        var lang = navigator.language;
        if (preferredLanguage && preferredLanguage != "") {
            lang = preferredLanguage;
        }

        // Perform the submit here
        fn(updateUrl).set('accept-language', lang).send(fullData).end(function (err, response) {
            if (err) {
                try {
                    subResp = JSON.parse(response.text);
                } catch (e) {
                    subResp = {};
                }

                setError(response.text)
                setPolicyMessages(subResp.policyMessages)
                setSaving(false)

            } else {
                 //Handle response from server with not OK status
                if (response.status !== 200) {
                    setError(response.body)
                    setSaving(false)
                } else {
                    // Looks like we succeeded, so just need to clear the policy messages
                    if (response.body.policyMessages && response.body.policyMessages.length > 0) {
                        let hasWarning = false;
                        for (let pm of response.body.policyMessages) {
                            if (pm.severity == 1) {
                                hasWarning = true;
                            }
                        }
                        if (response.body && response.body.data) {

                            setFullData(response.body.data)
                        }
                        
        
                        setSuppressWarnings(hasWarning)
                        setError("One or more policy violations has occurred")
                        setPolicyMessages(response.body.policyMessages)
                        setSaving(false)

                    } else {
                    // We are successful.  At this point, if the server is asking for a redirection, do that.
                        if (response.body.redirectToUrl) {
                            // Reiredt the user to the value that the server
                            window.location.href = response.body.redirectToUrl;
                            return;
                        }
                        if (response.body.redirectToReturnURL) {
                        // Reiredt the user to the value that the server
                            window.location.href = URLManager.getQueryStringValueByKey("returnURL", window.location.href);
                            return;
                        }
                        if (clearDataOnSubmit) {
                            var promises = Array<any>();

                            if (initDataUrl) {
                                promises.push(request.get(initDataUrl));
                            }
                            let data: any = initData || {};
                            if (promises.length > 0) {
                                Promise.all(promises).then((values) => {
                                    const resp = values[0];
                                    // Eventually, we may want to look into non-200 error codes, especially 205 for init data on "/new" routes
                                    if (resp.statusCode != 200) {
                                        setError(resp.body)
                                        setSaving(false)
                                        return;
                                    }
                                    data = resp.body;
                                    if (resp.body) {

                                        setSaving(false)
                                        setFullData(data)
                                        setSuccessToasterMessage(successMessage || "The item has saved successfully")
                                        setPolicyMessages(null)
                                        if (onAfterSubmitSuccess) {
                                            onAfterSubmitSuccess(response.body)
                                        }
                                        
                                    } else {
                                        setSaving(false)
                                        if (onAfterSubmitSuccess) {
                                            onAfterSubmitSuccess(response.body);
                                        }
                                    }
                                })
                                .catch((err) => {
                                    setSaving(false)
                                    handleAPIError(err)
                                });
                            } else {

                                setFullData(data)
                                setSuccessToasterMessage(successMessage || "The item has saved successfully")
                                setPolicyMessages(null)
                                setSaving(false)

                            }
                        } else {

                            setFullData(response.body.data)
                            setSuccessToasterMessage(successMessage || "The item has saved successfully")
                            setPolicyMessages(null)
                            setSaving(false)

                            if (onAfterSubmitSuccess) {
                                onAfterSubmitSuccess(response.body);
                            }
                            if (successRenderer) {
                                setShowSuccessRenderer(true)
                            }
                        }
                }
                }
            }
        });
    // });
    }

    const closeConfirmModal = () => {
        setCancelConfirm(false)
        setConfirmDelete(false)
    }

    const handleAsyncSubmit = () => {
        // If onBeforeSubmit<Promise> is not null, execute first and continue based on return
        if (onBeforeSubmitAsyncVerify) {
            onBeforeSubmitAsyncVerify().then((response) => {
                handleSubmit();
            })
            .catch((err) => {
                handleAPIError(err)
            });
        } else {
            handleSubmit();
        }
    }

    const handleCancel = () => {
        //reset the success message and clear the data
        if (confirmCancel) {
            setError(undefined)
            setCancelConfirm(true)
        } else {
            if (returnURL) {
                window.location.href = returnURL;
            }else if (cancelRedirectUrl) {
                window.location.href = cancelRedirectUrl;
            } else {
                 // check url for redirectURL
                var redirectUrl = URLManager.getQueryStringValueByKey(
                    "redirectUrl",
                    window.location.href
                );
                if (redirectUrl && redirectUrl != "") {
                    window.location.href = redirectUrl;
                } else {
                    // look at referrer to see if it's within our domain
                    if (document.referrer && document.referrer.indexOf(window.location.host) > -1) {
                        history.goBack();
                    } else {
                        // if its not go to dashboard.
                        window.location.href = "/";
                    }
                }
            }
        }
    }

    const handleCancelConfirm = () => {
        setCancelConfirm(false)
        if (returnURL) {
            window.location.href = returnURL
        }else if (cancelRedirectUrl) {
            window.location.href = cancelRedirectUrl
        } else {
            window.location.href = "/";
        }
    }

    const handleDeleteClick = () => {
        setConfirmDelete(true)
    }

    const handleDelete = () => {
        setSaving(true)
        request.delete(`${dataUrl}/${match.params.id}`).send(fullData).then(() => {
            if (returnURL) {
                window.location.href = returnURL
            } else {
                history.goBack();
            }
        })
        .catch((err) => {
            setSaving(false)
            setError(err)
        });
    }

    const editorInit = () => {
        var promises = Array<any>();
    
        if (!form) {
            var url = "/api/form-definitions/select?selector="+URLManager.getQueryStringValue(formSelector);
            if (preferredLanguage && preferredLanguage != ""){
                url += `&lang=${preferredLanguage}`
            }
            promises.push(request.get(url));
        }
    
        if (initDataUrl) {
            promises.push(request.get(initDataUrl));
        } else if (!data && !postOnly) {
            promises.push(request.get(dataUrl + "/" + match.params.id));
        }
    
        if (promises.length > 0) {
            Promise.all(promises)
            .then((values) => {
                let data: any = initData || {};
                // Values should have at least one element [0] that will be the form definition and may have 2 if editing and existing item
                switch (values.length) {
                case 2:
                    const resp2 = values[1];
                    // Eventually, we may want to look into non-200 error codes, especially 205 for init data on "/new" routes
                    if (resp2.statusCode != 200) {
                        if (errorFormSelector) {
                            request.get(
                            "/api/form-definitions/select?selector=" +
                                URLManager.getQueryStringValue(errorFormSelector)
                            ).then((formResponse: request.Response)=>{
                            
                            setError(resp2.body)
                            setFormDefinition(formResponse.body)
                            setStatus("ready")
        
                            }).catch((err) => {
                                setError(err)
                                setStatus("ready")
                            });
                        } else {
                            setError(resp2.body)
                            setStatus("ready")
                        }
                    
                        return;
                    }
    
                    data = resp2.body;
    
                    if (cachePaths && cachePaths.length > 0) {
                    // loop over paths and check for a correspondong cookie
                    cachePaths.forEach((path: string) => {
                        var ps = CookieManager.getCookie(
                        `formBasedEditorCachePath|${path}|${window.location.pathname}`
                        );
                        if (ps != "") {
                        // attempt to set the path value using cookie
                        try {
                            var parsed = JSON.parse(ps);
                            let svpResp = setValueAtPath(path, data, parsed);
                            data = svpResp.data;
                        } catch (e) {
                            // cached value just does not get applied
                        }
                        }
                    });
                    }
                // Fall through since if you have 2 you also have 1
                case 1:
    
                    const resp = values[0];
    
                    if (resp.statusCode != 200) {
                        setError(resp.body)
                        setStatus("ready")
                        return;
                    }
    
                    const rv: string = resp.body.requireCaptchaVersion;
    
                    const usingCaptcha: boolean = rv != null && (window["App"].browserEnvironment || {}).BROWSER_RECAPTCHA_SITE_KEY;
    
                    setFormDefinition(resp.body)
                    setFullData(data)
                    setRequireCaptcha(usingCaptcha)
                    setRecaptchaVersion(rv)
                    setStatus("ready")
                    break;
    
                default:
                    // should not be getting here unless something is very wrong
                    setError("An unknown error has occurred accessing the item")
                    setStatus("ready")
                }
            })
            .catch((err) => {
                if (errorFormSelector) {
                request.get(
                    "/api/form-definitions/select?selector=" +
                    URLManager.getQueryStringValue(errorFormSelector)
                ).then((formResponse: request.Response)=>{
                    setError(err)
                    setFormDefinition(formResponse.body)
                    setStatus("ready")
                }).catch((err) => {
                    setError(err)
                    setStatus("ready")
                });
                } else {
                    setError(err)
                    setStatus("ready")
                }
            });
        } else {

            let _fullData: any = data || initData || {}

            if (cachePaths && cachePaths.length > 0) {
                // loop over paths and check for a correspondong cookie
                cachePaths.forEach((path: string) => {
                    var ps = CookieManager.getCookie(
                        `formBasedEditorCachePath|${path}|${window.location.pathname}`
                    );
                    if (ps != "") {
                        // attempt to set the path value using cookie
                        try {
                            var parsed = JSON.parse(ps);
                            let svpResp = setValueAtPath(path, _fullData, parsed);
                            _fullData = svpResp.data;
                        } catch (e) {
                            // cached value just does not get applied
                        }
                    }
                });
            }

            setFullData(_fullData)
            setFormDefinition(form)
            setStatus("ready")
        }
    }

    useEffect(() => {
        if (task) {
            CookieManager.setCookie(`getNextEnabled|${task.taskType}`, `${getNextEnabled}`, 30)
        }
    }, [getNextEnabled])
    
    useEffect(() => {

        if (containerType == ContainerTypeEditor) {
            editorInit()
        } else {
            var {id} = match.params

            var promises = Array<any>()

            if (containerType == ContainerTypeTask) {

                var route = "lock"
                if (readOnly) {
                    route = "fetch"
                }

                if (route == "lock") {
                     /* 
                        ATTENTION:

                        We're commenting this out for now. The variables that are used inside the onbeforeunload function do not appear
                        to be getting updated when tasks are processed.

                     window.onbeforeunload = () => {
                        if (unlockOnbeforeUnload) {
                            var unlockURL = `/api/${dataUrl}/tasks/${id}/unlock`;
                            if (!skipSSEBroadcast() && broadcastUrl) {
                                unlockURL += `?broadcastUrl=${broadcastUrl}`
                            }
                            request.put(unlockURL).then((response: request.Response)=>{})
                            
                        }
                    }

                    */
                }
            
                if (channelOverrides) {

                    var { lockChannel, fetchChannel } = channelOverrides

                    if (lockChannel) {
                        route += `?lockChannelOverride=${lockChannel}`
                    }

                    if (fetchChannel) {
                        route += `${route.indexOf("?") > -1 ? "&" : "?"}fetchChannelOverride=${fetchChannel}`
                    }

                }
            
                route += `${route.indexOf("?") > -1 ? "&" : "?"}taskOnly=false`
                if (!skipSSEBroadcast() && broadcastUrl) {
                    route += `&broadcastUrl=${broadcastUrl}`
                }
            
                promises.push(request.get(`/api/${dataUrl}/tasks/${id}/${route}`))

            } else {
                promises.push(request.get(dataUrl + "/" + id))
            }

            if (formSelector) {
                promises.push(request.get('/api/form-definitions/select?selector=' + JSON.stringify(formSelector)))
            }

            if (introTemplateSelector) {
                promises.push(request.get('/api/portal-templates/select?selector=' + JSON.stringify(introTemplateSelector)))
            }

            if (summaryTemplateSelector) {
                promises.push(request.get('/api/portal-templates/select?selector=' + JSON.stringify(summaryTemplateSelector)))
            }

            Promise.all(promises).then((values) => {

                var _fullData, _task, _taskType, _entity, _formDefinition, _actionDefinition, _submitAction, _introTemplate, _summaryTemplate

                _actionDefinition = values[0].body.actionDefinition
                _formDefinition = values[0].body.formDefinition

                if (!_formDefinition && formSelector) {
                    _formDefinition = values[1].body
                }

                if (introTemplateSelector) {
                    _introTemplate = formSelector ? values[2].body : values[1].body
                }
                
                if (summaryTemplateSelector) {
                    if (formSelector && introTemplateSelector) {
                        _summaryTemplate = values[3].body
                    } else if (!formSelector && !introTemplateSelector) {
                        _summaryTemplate = values[1].body
                    } else {
                        _summaryTemplate = values[2].body
                    }
                }

                if (containerType == ContainerTypeTask) {

                    _task = values[0].body.task
                    _taskType = values[0].body.taskType

                    _fullData = values[0].body.task.taskData[_formDefinition.key]
                    if (useRootTaskData) {
                        _fullData = values[0].body.task.taskData
                    }

                    // getNextEnables is stored in a cookie.
                    var getNextAvailable = isGetNextAvailable(_actionDefinition)
                    var getNextEnabled: boolean = false;
                    if (getNextAvailable) {
                        var gne = CookieManager.getCookie(`getNextEnabled|${_taskType.key}`)
                        if (gne == "true") {
                            getNextEnabled = true
                        }
                    }

                    // submit action is used by the sequence viewer to display a submit button within the last section
                    var sa: any = undefined
                    for (let action of _actionDefinition.definition.actions) {
                        if (action && action.submitAction) {
                            sa = action
                        }
                    }

                    setSubmitAction(sa)
                    setGetNextAvailable(getNextAvailable)
                    setGetNextEnabled(getNextEnabled)

                } else {
                    _entity = values[0].body.entity || values[0].body.data

                    _fullData = values[0].body.entity || values[0].body.data
                    if (entityDataField) {
                        _fullData = _fullData[entityDataField]
                        if (!preventFormDefDataKey) {
                            _fullData = _fullData[_formDefinition.key]
                        }
                    }

                }

                setTask(_task)
                setTaskType(_taskType)
                setEntity(_entity)
                setFormDefinition(_formDefinition)
                setActionDefinition(_actionDefinition)
                setFullData(_fullData)
                setIntroTemplate(_introTemplate)
                setSummaryTemplate(_summaryTemplate)
                setStatus("ready")
            
            }).catch((err)=>{
                handleAPIError(err, true)
            })
        }
        
    }, [])

    useEffect(() => {
        if (currentKeyMap && currentKeyMap.length > 0) {
            // The current keymap will be an array.  Loop over it
            for(let keyMap of currentKeyMap) {

                // Split the key action into parts
                var keyParts = keyMap.action.split(".")
                // If the first part, lowercased, is "formcontainer", then we know this is a key map relevent to the form container
                if (keyParts[0].toLowerCase() == "formcontainer") {
                    //if the second part is "action", then we know this is an action key
                    if (keyParts[1].toLowerCase() == "action" && keyParts.length > 2) {
                        // Determine Action based on key press
                        const actionKey = keyParts[2].toLowerCase()

                        // This is to handle occasions where there might not be an action key, but the action is among the common
                        // action titles, such as "Complete", "Cancel", etc.
                        // Action keys are more veristile and do not need to be unique, so are preferable to the action tilte hack.
                        const actionDerivedTitle = actionKey.replaceAll(" ", "" ).toLowerCase()

                        if (actionDefinition && actionDefinition.definition && actionDefinition.definition.actions) {

                            for (let action of actionDefinition.definition.actions) {
                                // Action key is the preferred way to map the actions to the key map action verb 
                                if ((action.key && action.key == actionKey) || 
                                    // is a backup to the action key
                                (action.title.toLowerCase().replace(" ", "") == actionDerivedTitle)) {
                                    // setCurrentKeyMap(null);
                                    handleAction(action)
                                }
                            }
                        }
                    }
                    //Only set to null if you consumed the key
                    // Set the current Key map to null, to reset for next key
                    setCurrentKeyMap(null);
                }
            }

        }

    
    }, [currentKeyMap])
    

    var definitionView = renderDefinitionView()

    var scrollToTop:any = null;
    if (showScrollToTop) {
        scrollToTop = (<IconButton tabIndex={-1} onClick={()=>{window.scrollTo(0,0)}}><i style={{...theme.scrollToTopArrow, position:'fixed', bottom:10, right: 15, opacity: .4, cursor: 'pointer', zIndex: 10000}} className="fa fa-arrow-up scrollToTopArrow" /></IconButton>)
    }

    var errorView;
    if (error) {
        errorView = <ErrorView classes={{}} error={error} onClose={onErrorViewClose} />;
    }

    var successView: any = null;
    if (successToasterMessage) {
        successView = (<SuccessView onClose={handleSuccessMessageClose} message={successToasterMessage}/>);
    }

    var warningView;
    if (warningMessage) {
        warningView = <SuccessView isWarning={true} message={warningMessage} onClose={onWarningViewClose} classes={{}} />;
    }

    if (status == "loading") {
        return (
            <div>
                {errorView}
                <LoadingView classes={{}} />
            </div>
        )
    }

    var modal 
    if (actionDialogue) {
        if (actionDialogue.dialogueOptions && actionDialogue.dialogueOptions.renderer) {
            let DialogueRenderer = Renderers.find(actionDialogue.dialogueOptions.renderer);
            if (DialogueRenderer) {
                // MV 2021-12-16 adding data as a property since task does not get all updates (GL) for realtime data usage in approval simulator
                let updatedData:any = null;
                if (task) {
                    updatedData = cloneDeep(task)
                    updatedData.taskData = cloneDeep(fullData || {})
                } 
                modal = <DialogueRenderer open={true} data={updatedData} task={task} entity={entity} action={actionDialogue} handleClose={handleModalClose} handleDispatch={handleDispatch}/>	
            } else {
                console.warn(`Renderer ${actionDialogue.dialogueOptions.renderer} not found`)
            }
        } else {
            modal = (
                <FormBasedContainerDialogue task={task} entity={entity} open={true} action={actionDialogue} handleClose={handleModalClose} handleDispatch={handleDispatch} />
            )
        }
    }

    var CustomInfo
    if (customInfoSectionRenderer) {
        CustomInfo = Renderers.find(customInfoSectionRenderer)
    }
    
    var actionContainerClass = classes.actionsContainer
    if (sequenceView) {
        actionContainerClass = classes.sequenceActionsContainer
    }

    var cancelButton, deleteButton
    if (containerType == ContainerTypeEditor) {

        if (confirmDelete) {

            modal = (
              <SimpleConfirmationModal
                terminal={true}
                open={true}
                confirmationMessage={
                  confirmDeleteMessage || "Are you sure you want to delete this?"
                }
                onClose={closeConfirmModal}
                onConfirm={handleDelete}
              />
            );
          }

        if (cancelConfirm) {
            modal = (
              <SimpleConfirmationModal
                terminal={true}
                open={true}
                confirmationMessage={
                  confirmCancelMessage || "Are you sure you want to cancel?"
                }
                onClose={closeConfirmModal}
                onConfirm={handleCancelConfirm}
              />
            );
          }

        if (!hideCancelButton) {
            cancelButton = (
              <Button
                className={classes.actionBarButton}
                variant="contained"
                onClick={handleCancel}
                disabled={status === "saving"}
                color="inherit"
              >
                {" "}
                {translate(cancelButtonText || "Cancel")}{" "}
              </Button>
            );
        }
        if (allowDelete && match.params.id != "new") {
            deleteButton = (
              <Button
                className={classes.deleteButton}
                variant="contained"
                color="primary"
                onClick={handleDeleteClick}
                disabled={status === "saving" || (returnURL && status === "saved")}
              >
                {deleteButtonText || "Delete"}
              </Button>
            );
          }
    }



    const tabToNextAvailableElement = (event:any, reset:boolean) => {
        // Get all focusable elements and set focus to the next tabable element
        let fe = document.querySelectorAll('input');
        if (!reset) {
            fe = document.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
        }
        
        // Convert the fe NodeList to an array
        const fa = Array.prototype.slice.call(fe);
        
        if (reset){
            // Find the first enabled input and set focus
            fa.find((el:any)=>{return !el.disabled})?.focus()
        } else {
            // Get the current index of the active element 
        const ci = fa.indexOf(document.activeElement);
            // Set focus to the next element
            if (ci >= 0 && ci < fa.length - 1) {
                fa[ci + 1].focus();
            }
        }
    }

    const getSuccessRenderer = (data:any) => {
        if (successRenderer) {
            const SuccessRenderer = RendererRegistry.find(successRenderer);
            if (SuccessRenderer) {
                return (
                    <div className={classes.container}>
                        <Paper className={classes.headerPaper}>
                        <SuccessRenderer data={data}></SuccessRenderer>
                        </Paper>
                        <div className={classes.actionBar}>
                        <Button
                            className={classes.actionBarButton}
                            variant="contained"
                            color="primary"
                            onClick={handleCancel}
                            disabled={false}
                        >
                            {"Done"}
                        </Button>
                        </div>
                    </div>
                );
            }
        }
    }


    if (showSuccessRenderer) {
        return (<div>{getSuccessRenderer(fullData)}</div>)
    } else {
        return (
            <div className="form-based-container-fc">
                {errorView}
                {warningView}
                {successView}

                <DefinitionDataProvider>
                {modal} 
                </DefinitionDataProvider>
                <span tabIndex={0} onFocus={tabToNextAvailableElement}  id="prevent-outside-tab"></span>
                {actionDefinition && <div className={actionContainerClass}>
                    <FormBasedActions
                        classes={{}}
                        disabled={false}
                        actionDefinition={actionDefinition}
                        setActionDefinition={setActionDefinition}
                        handleAction={handleAction}
                        mode={actionBarMode}
                        getNextAvailable={getNextAvailable}
                        getNextEnabled={getNextEnabled}
                        setGetNextEnabled={setGetNextEnabled}
                        task={task}
                    />
                </div>}

                {(dispatching || saving) && <LoadingView text={" "} overlay={true} classes={{}} />}

                {task && !sequenceView && <div className={classes.instructionContainer}>
                    <InstrtuctionsView task={task} />
                </div>
                }

                {CustomInfo && task &&  (
                    <div className={classes.customInfoSectionRenderer}>
                        <CustomInfo task={task} />
                    </div>
                )}

                {definitionView}

                {containerType == ContainerTypeEditor && <div className={classes.editorActionBar}>
                    {cancelButton}
                    {!readOnly && formDefinition && (
                        <Button
                            className={classes.editorActionBarButton}
                            variant="contained"
                            color="primary"
                            onClick={handleAsyncSubmit}
                            disabled={status === "saving" || status === "errorForm" || (returnURL && status === "saved") || requireCaptcha}
                            >
                            {translate(submitButtonText || "Save")}
                        </Button>
                    )}
                    {deleteButton}
                </div>}

                {recaptchaVersion == "v2" &&
                    (window["App"].browserEnvironment || {})
                    .BROWSER_RECAPTCHA_SITE_KEY && (
                    <ReCaptchaV2
                        sitekey={
                            window["App"].browserEnvironment.BROWSER_RECAPTCHA_SITE_KEY
                        }
                        onChange={onCaptchaChange}
                    />
                )}

                {scrollToTop}
                <span tabIndex={0} onFocus={()=>{window.scrollTo(0,0); document.getElementById("prevent-outside-tab")?.focus()}}></span>
            </div>
        );
    }
};

export default FormBasedContainer;
